// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"76efcb82","453":"fd0f8c1d","693":"bf59e3a8","861":"49e160b6"}[chunkId] + ".chunk.js";
};